import React from 'react';
import ContentPage from './ContentPage';

// Content lives in the content_pages table (#66/#122); see ContentPage.js.
function Faq() {
  return <ContentPage slug="faq" title="FAQ" />;
}

export default Faq;
